const API_BASE = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8007/api';

function assert(condition, message) {
  if (!condition) throw new Error(message);
}

export const apiHealthTests = [
  {
    id: 'health-1',
    name: 'Backend /api/user responds (not 5xx)',
    run: async () => {
      try {
        const response = await fetch(`${API_BASE}/user`, {
          method: 'GET',
          headers: { Accept: 'application/json' },
        });
        assert(response.status < 500, `Backend returned ${response.status} — server error`);
        assert(
          [200, 401, 403, 419].includes(response.status),
          `Unexpected status: ${response.status} (expected 200/401/403/419)`
        );
      } catch (err) {
        if (err.name === 'TypeError' || err.message.includes('fetch')) {
          throw new Error(
            `Backend not reachable at ${API_BASE} — start it with: php artisan serve --host=0.0.0.0 --port=8007`
          );
        }
        throw err;
      }
    },
  },
  {
    id: 'health-2',
    name: 'CSRF cookie endpoint responds',
    run: async () => {
      const baseUrl = API_BASE.replace('/api', '');
      try {
        const response = await fetch(`${baseUrl}/sanctum/csrf-cookie`, {
          method: 'GET',
          headers: { Accept: 'application/json' },
        });
        assert(
          [200, 204, 302, 419].includes(response.status),
          `Unexpected CSRF status: ${response.status}`
        );
      } catch (err) {
        if (err.name === 'TypeError' || err.message.includes('fetch')) {
          throw new Error('CSRF endpoint not reachable — backend may be down');
        }
        throw err;
      }
    },
  },
  {
    id: 'health-3',
    name: 'Login endpoint responds (not 5xx)',
    run: async () => {
      try {
        const response = await fetch(`${API_BASE}/login`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ email: 'health@check.test', password: 'healthcheck123' }),
        });
        assert(response.status < 500, `Login endpoint returned ${response.status}`);
        assert(
          [200, 401, 422, 429].includes(response.status),
          `Unexpected login status: ${response.status}`
        );
      } catch (err) {
        if (err.name === 'TypeError' || err.message.includes('fetch')) {
          throw new Error('Login endpoint not reachable — backend may be down');
        }
        throw err;
      }
    },
  },
  {
    id: 'health-4',
    name: 'CORS allows frontend origin (no NetworkError)',
    run: async () => {
      try {
        const response = await fetch(`${API_BASE}/user`, {
          method: 'GET',
          headers: { Accept: 'application/json' },
          mode: 'cors',
        });
        assert(response.status !== undefined, 'Response received — CORS is allowing requests');
      } catch (err) {
        if (err.name === 'TypeError' && err.message.toLowerCase().includes('network')) {
          throw new Error(
            `CORS blocked: backend not allowing origin http://localhost:3007. Check config/cors.php`
          );
        }
        if (err.name === 'TypeError' || err.message.includes('fetch')) {
          throw new Error('Backend not reachable for CORS check');
        }
        throw err;
      }
    },
  },
];
